module.exports = __webpack_public_path__ + "img/menu.f81b64b6.svg";